import { Carousel } from '@leland-dev/leland-ui-library';
import React from 'react';

import { type Scalars } from '../../__generated-gql-types__/globalTypes';
import LoadingIndicator from '../common/LoadingIndicator';

import ReviewCard from './ReviewCard';
import {
  type ReviewSliderCoachFragment,
  useReviewSliderReviewsForCoachQuery,
} from './__generated-gql-types__/ReviewSlider.generated';

interface ReviewSliderProps {
  coach: ReviewSliderCoachFragment;
  viewAllReviews: () => void;
  categoryUrn: Scalars['CategoryUrn']['output'];
  className?: string;
}

const ReviewSlider: React.FC<ReviewSliderProps> = ({
  coach,
  viewAllReviews,
  categoryUrn,
  className = '',
}) => {
  const { data: categoryReviews, loading: categoryReviewsLoading } =
    useReviewSliderReviewsForCoachQuery({
      variables: {
        id: coach?.id ?? '',
        categoryUrnFilter: categoryUrn,
      },
    });

  // Only display reviews that have comments
  const cleanedCategoryReviewsForCoach =
    categoryReviews?.reviewsForCoach?.results.filter(
      (review) => review.comment,
    );

  return categoryReviewsLoading ? (
    <div className="my-8 w-full text-center text-base">
      <LoadingIndicator iconClassName="w-7 h-7" />
    </div>
  ) : cleanedCategoryReviewsForCoach &&
    cleanedCategoryReviewsForCoach.length > 0 ? (
    <div className={`w-full ${className}`}>
      <div className="mb-3 flex w-full flex-col justify-between md:flex-row">
        <p className="text-base font-normal text-leland-gray-light">
          Reviews from {coach.user.firstName}&rsquo;s clients
        </p>
        <button
          className="link link--primary text-left text-base font-medium"
          onClick={viewAllReviews}
          id="review_slider--view_all_reviews"
        >
          See all reviews
        </button>
      </div>
      <Carousel
        swiperProps={{
          slidesPerGroupAuto: false,
          spaceBetween: 20,
          slidesPerView: 1,
        }}
        disableArrowGradient
        items={cleanedCategoryReviewsForCoach.map((review) => {
          return (
            <ReviewCard className="w-full" key={review.id} review={review} />
          );
        })}
      />
    </div>
  ) : null;
};

export default ReviewSlider;
